import React from 'react';
import Head from 'next/head';

type HelmetProps = {
  title: string;
  description: string;
  keywords?: string[];
  children?: React.ReactNode;
};

const BounceHelmet: React.FC<HelmetProps> = ({
  title,
  description,
  keywords,
  children
}) => {
  let metaKeywords = 'bounce,events,p2p,payment,qr,cashless';
  if (keywords) {
    metaKeywords += `,${keywords}`;
  }
  return (
    <Head>
      <title>{title ? `${title} | Bounce` : 'Bounce'}</title>
      {description && <meta name="description" content={description} />}
      <meta name="keywords" content={metaKeywords} />
      {children}
    </Head>
  );
};

export default BounceHelmet;
